import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import {
  competitorsSnapshotDocOctoberKeys,
  competitorsSnapshotKeys,
  TCompetitorsSnapshot,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { ICompetitor } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { getFormedEltTranslationForKeys } from '../../../helpers/getFormedEltTranslationForKeys'

import { formCompetitorsFromFinancialData } from './formCompetitorsFromFinancialData'
import { getEmptyRows } from './getEmptyRows'

export const getCompetitorsInitialData = (
  initialData: TCompetitorsSnapshot | null,
  eltType: EltType
): ICompetitor[] => {
  const snapshotKeys =
    eltType === EltType.DocOctober25 || eltType === EltType.DocJanuary26
      ? competitorsSnapshotDocOctoberKeys
      : competitorsSnapshotKeys
  if (!initialData) {
    return snapshotKeys
      .filter((key) => key !== 'CompetitorsPoly')
      .map((key) => ({
        Category: key,
        CategoryName: getFormedEltTranslationForKeys(key),
        Competitors: [{ HPSow: 0, YoY: 0, Name: 'HP' }, ...getEmptyRows(2)],
      }))
  }

  return formCompetitorsFromFinancialData(initialData, snapshotKeys)
}
